import { render, staticRenderFns } from "./d-post-book.vue?vue&type=template&id=65315afe&scoped=true&"
import script from "./d-post-book.vue?vue&type=script&lang=js&"
export * from "./d-post-book.vue?vue&type=script&lang=js&"
import style0 from "./d-post-book.vue?vue&type=style&index=0&id=65315afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65315afe",
  null
  
)

export default component.exports